import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { banks } from '../../data/banks.js';
import THEME from '../../theme.js';
import Button from '../Button.js';
const BankAccount = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        React.createElement("div", null,
            props.accountDetails.registrationNumber,
            "-",
            props.accountDetails.accountNumber),
        React.createElement(Bank, null, banks[props.accountDetails.registrationNumber] || 'Ukendt bank'),
        props.editable && (React.createElement(Button, { size: "small", theme: "secondary", onClick: props.onEdit }, lang.misc.update))));
};
export default BankAccount;
const Bank = styled.div `
  font-size: 0.8em;
  color: ${THEME.TEXT_MUTED};
  margin-bottom: 1rem;
`;
//# sourceMappingURL=BankAccount.js.map